import FixedRangePicker, { type FixedRangePickerFieldProps } from '../../../components/fields/FixedRangePickerField';
import CalendarIcon from '../../../icons/mobility/calendar.svg';
import { RangePickerContainer } from './RangePickerField';

const FixedRangePickerField = (props: FixedRangePickerFieldProps) => (
    <RangePickerContainer>
        <FixedRangePicker {...props} suffixIcon={<CalendarIcon />} />
    </RangePickerContainer>
);

export default FixedRangePickerField;
